// File: src/pages/mentor-park/ResourcesCertificationsPage.jsx
// Description: Scaffold for Resources & Certification Recommendations

import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const ResourcesCertificationsPage = () => {
  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>Resources & Certification Recommendations</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        Curated courses and certifications to boost your career.
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">Coming soon.</Typography>
      </Paper>
    </Box>
  );
};

export default ResourcesCertificationsPage;


